import React from 'react'
import S from '../StoreSelectorTooltip/styles'
import JwcIcon from './../../static/jwc/jwc-pdp.svg'
import InfoIcon from './../../static/Info/InfoIcon'
import { SCREEN_SIZE, Media } from '../../lib/Media'
import { getJwcUrl } from '../../utils/jwcUtils'

class JwcTag extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showTooltip: false,
      jwcTooltipConfig: {},
    }
    this.toggleJwcTooltip = this.toggleJwcTooltip.bind(this)
    this.handleCtaClick = this.handleCtaClick.bind(this)
    this.setRcValues = this.setRcValues.bind(this)
  }

  setRcValues() {
    this.setState({
      jwcTooltipConfig: {
        'enabled': true,
        'tooltipHeader': 'Just Wine Club',
        'tooltipBody':
          'Members enjoy 8% off on selected wines online & in-store!',
        'tooltipCta': 'Learn more',
        'tooltipCtaLink': getJwcUrl(),
        'tooltipCtaLinkTarget': '_blank',
      },
    })
  }

  toggleJwcTooltip(toggleState) {
    if (this.state.showTooltip !== toggleState) {
      this.setState({ showTooltip: toggleState })
    }
  }

  handleCtaClick() {
    const { jwcTooltipConfig } = this.state
    window.open(
      jwcTooltipConfig?.tooltipCtaLink,
      jwcTooltipConfig?.tooltipCtaLinkTarget
    )
    this.toggleJwcTooltip(false)
  }

  componentDidMount() {
    this.setRcValues()
  }

  render() {
    const { showTooltip, jwcTooltipConfig } = this.state
    return (
      <S.StyledJwcTagWrapper className="jwcTag" data-testid="jwc-tag-wrapper">
        <S.StyledJwcIcon>
          <img src={JwcIcon} />
        </S.StyledJwcIcon>
        <S.StyledInfoIcon
          data-testid="jwc-tooltip-info"
          onClick={() => this.toggleJwcTooltip(true)}
        >
          <InfoIcon />
          {showTooltip && (
            <S.StyledJwcTooltipWrapper data-testid="jwc-tooltip">
              <Media query={SCREEN_SIZE.Only.Mobile}>
                <S.StyledArrowUp arrowLeft="8rem" arrowTop="0.0625rem" />
              </Media>
              <Media query={SCREEN_SIZE.From.MobileL}>
                <S.StyledArrowUp arrowLeft="2.4375rem" arrowTop="0.0625rem" />
              </Media>
              <S.StyledTooltipBody>
                <S.StyledHeaderWrapper>
                  <S.StyledTitleText>
                    {jwcTooltipConfig?.tooltipHeader}
                  </S.StyledTitleText>
                  <S.StyledCloseIcon
                    data-testid="jwc-tooltip-close"
                    onClick={() => this.toggleJwcTooltip(false)}
                    width="1.5rem"
                    height="1.5rem"
                  />
                </S.StyledHeaderWrapper>
                <S.StyledContent fontSize="1rem">
                  {jwcTooltipConfig?.tooltipBody}
                </S.StyledContent>
                <S.StyledButton
                  data-testid="jwc-tooltip-cta"
                  onClick={this.handleCtaClick}
                >
                  {jwcTooltipConfig?.tooltipCta}
                </S.StyledButton>
              </S.StyledTooltipBody>
            </S.StyledJwcTooltipWrapper>
          )}
        </S.StyledInfoIcon>
      </S.StyledJwcTagWrapper>
    )
  }
}

export default JwcTag
